import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import {MenuHomeEnum} from 'app/home';
import { CreateMerchantPayoutAccountRequestDto } from '../models/lokal/create-payout-account-request';
import { ByMerchantRequestDto, UpdateMerchantPayoutAccountRequestDto } from 'app/models';
import { MartOnboardingDto } from '../components/home/partners/mart-onboarding/interfaces/mart-onboarding-dto';

@Injectable()
export class MerchantService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getMerchants(data: MartOnboardingDto, value: MenuHomeEnum, messageService: MessageService): Promise<any> {
        return this.apiHttp.post(`api/AdminMerchant/${MenuHomeEnum[value]}/GetMerchants`, data, messageService);
    }

    public createMerchant(data: any, value: MenuHomeEnum, messageService: MessageService): Promise<any> {
        return this.apiHttp.post(`api/MerchantUser/${MenuHomeEnum[value]}/CreateMerchant`, data, messageService);
    }

    public detailMerchant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/DetailMerchant', data, messageService);
    }

    public merchantCompanyUpdate(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/MerchantCompanyUpdate', data, messageService);
    }

    public merchantStatusChange(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/MerchantStatusChange', data, messageService);
    }

    public merchantDocumentUpload(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/MerchantDocumentUpload', data, messageService);
    }

    public approveMerchantDocs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ApproveMerchantDocs', data, messageService);
    }

    public getMerchantDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetMerchantDocuments', data, messageService);
    }

    public rejectMerchantApplication(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/RejectMerchantApplication', data, messageService);
    }

    public changeMerchantStoreStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ChangeMerchantStoreStatus', data, messageService);
    }

    public getMerchantPayoutAccount(data: ByMerchantRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetMerchantPayoutAccount', data, messageService);
    }

    public getMerchantPayoutAccounts(data: ByMerchantRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetMerchantPayoutAccounts', data, messageService);
    }

    public createMerchantPayoutAccount(data: CreateMerchantPayoutAccountRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/CreateMerchantPayoutAccount', data, messageService);
    }

    public updateMerchantPayoutAccount(data: UpdateMerchantPayoutAccountRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/UpdateMerchantPayoutAccount', data, messageService);
    }

    public deleteMerchantPayoutAccount(payload: ByMerchantRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/DeleteMerchantPayoutAccount', payload, messageService);
    }

    public getReviewPartnerInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetReviewPartnerInfo', data, messageService);
    }

    public getMerchantVerificationCheckLists(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetMerchantVerificationCheckLists', data, messageService);
    }

    public addOrUpdateMerchantVerificationCheckList(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/AddOrUpdateMerchantVerificationCheckList', data, messageService);
    }

    public approvedOrRejectMerchantPayoutAccountStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ApprovedOrRejectMerchantPayoutAccountStatus', data, messageService);
    }

    public approvedMerchantStoreStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ApprovedMerchantStoreStatus', data, messageService);
    }

    public suspendMerchant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/SuspendMerchant', data, messageService);
    }

    public updateBusinessInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Merchant/UpdateBusinessInfo', data, messageService);
    }

    public changeMerchantImage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ChangeMerchantImage', data, messageService);
    }

    public removeMerchantImage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/RemoveMerchantImage', data, messageService);
    }

    public resetPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/ResetPassword', data, messageService);
    }

    public getMerchantsForCombo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminMerchant/GetMerchantsForCombo', data, messageService);
    }

    public setClosed(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Merchant/Store/SetClosed', data, messageService);
    }
}
